module.exports = __webpack_public_path__ + "img/bg.831c9796.png";